import React from 'react';
import Responsive from 'react-responsive';
import { MOBILE_BREAKPOINT_MAX } from '../../../config/consts';

const Mobile = props => <Responsive {...props} maxWidth={MOBILE_BREAKPOINT_MAX} />;

export default Mobile;
